export default "__VITE_ASSET__456ee91d__"